import React from 'react';
import { Bar } from "react-chartjs";

function setTooltip(res) {
}
const chartOptions = {
    scaleShowHorizontalLines: true,
    responsive: true,
    barValueSpacing : 10,
    tooltips: {
        enabled: false,
        custom: setTooltip
    }
};

const tokenUtilization = ({chartData, responsiveHeight}) => {
    responsiveHeight = (!responsiveHeight) ? 90 : '';
    return (
        <div>
            <Bar data={chartData} options={chartOptions} height={responsiveHeight}/>
        </div>
    );
};

export default tokenUtilization;



// WEBPACK FOOTER //
// ./src/Regional-Views/Dashboard/graphs/tokenUtilization.js